import { apiCall } from "../../services/api-service";

/**
 * Fetches workload data based on view (Monthly, Weekly)
 * @param {string} view - "Monthly" or "Weekly"
 * @param {string} period - Formatted date string (YYYY-MM or YYYY-MM-DD)
 * @param {string} search - Search term for members
 */
export const fetchWorkloadData = async (view, period, search, limit = 10, skip = 0) => {
  const endpointMap = {
    Daily: "workload/monthly",
    Monthly: "workload/monthly",
    Weekly: "workload/weekly"
  };

  const response = await apiCall("get", endpointMap[view] || endpointMap.Monthly, null, {
    params: {
      period,
      search,
      limit,
      skip
    }
  });

  return response;
};

/**
 * Fetches specific member workload details for a given date/period
 * @param {number|string} empId - Employee ID
 * @param {string} period - Date string (YYYY-MM-DD)
 */
export const fetchUserWorkloadData = async (empId, period) => {
  const payload = {
    emp_id: empId,
    period: period
  };

  // Try POST first
  let response = await apiCall("post", "workload/user", payload);

  // Fallback to GET if 405 Method Not Allowed
  if (response && response.status === 405) {
    response = await apiCall("get", `workload/user?emp_id=${empId}&period=${period}`);
  }

  return response;
};

/**
 * Updates the ticket assignment
 * @param {object} payload - { id, team_id, assign_to, remarks }
 */
export const updateAssignTo = async (payload) => {
  const response = await apiCall("put", "ticket/update_assign_to", payload);
  return response;
};
